import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../RgInteraction.module.scss';

const CasinoSession = ({
  closeRgPopup,
  goToRgTools,
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Please Gamble Responsibly
      </div>
      <div className={styles.bold}>
        {'Do you know how long your last session was? Playing for long periods of time can increase the risk of gambling related harm.'}
      </div>
      <div>
        <span>{'Research shows that taking regular breaks and setting up a deposit limit which suits your budget and sticking to it is an effective method to remain in control.'}</span>
        <br />
        <br />
        <span>{'Would you like to review your Safer Gambling settings?'}</span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeRgPopup}
      >{"No, I'm fine for now"}</Button>
      <Button
        sizeType="wider"
        buttonType="primary"
        onClick={goToRgTools}
        className={styles.primaryButton}
      >Yes, Review my settings</Button>
    </div>
  </Fragment>
);

CasinoSession.propTypes = {
  closeRgPopup: PropTypes.func.isRequired,
  goToRgTools: PropTypes.func.isRequired,
};

export default CasinoSession;

